import cn from '@/lib/cs';
import { memo } from 'react';

const LabelBackground = memo(
	({
		className,
		strokeColor,
	}: {
		className?: string;
		strokeColor?: string;
	}) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 121 44"
			className={cn(
				'absolute inset-0 size-full pointer-events-none overflow-visible',
				className
			)}
			preserveAspectRatio="none"
		>
			<path
				fill="currentColor"
				style={{
					stroke: strokeColor,
					strokeWidth: strokeColor ? 2.5 : 0,
				}}
				d="M0 22V11c1-4 5-5 8-6l6-2 7-1 15-1 31-1a111 111 0 0117 1h5l7 1 14 2a19 19 0 014 0l3 2c2 2 3 5 3 8l1 9c0 7-3 14-11 17l-10 2-15 2a237 237 0 01-46-1l-7-1h-7l-7-1c-5 0-9 0-12-2-8-3-6-12-6-17z"
			/>
		</svg>
	)
);

export default LabelBackground;
